import CaseStudy from "../../components/casestudy/CaseStudy";
import AgriMid from "../../assets/casestudy/images/AgriMid.jpg";
import AgriTop from "../../assets/casestudy/images/AgriTop.jpg";
import FleetTop from "../../assets/casestudy/images/FleetTop.jpg";
import {
  Achievement,
  Strategic,
  Accelerated,
  Cost,
  Operational,
  Errors,
  Automated,
  Dashboards,
  Fleet,
  Time,
} from "../../controller/Images";

function CaseStudyTwo() {
  const mockProps = {
    tagLabel: "CASE STUDY",
    pageTitle:
      "Ensuring Stability in Agritech SaaS: Leadership Transition Without Disruption",
    bannerImage: AgriTop,
    clientStory:
      "A high-growth Agritech SaaS platform providing innovative solutions to agricultural processors and supply chain enterprises, enabling real-time visibility, efficiency, and optimization across the agricultural value chain.",
    title: "Key Details",
    details: [
      { label: "Domain", value: "Agritech, Agricultural Supply Chain" },
      { label: "Industry", value: "SaaS / Enterprise Software" },
      {
        label: "Service Type",
        value: "Managed Services (Application & Cloud Operations)",
      },
      {
        label: "Engagement Model",
        value: "End-to-end ownership with defined SLAs",
      },
      {
        label: "Technology Focus",
        value: "SaaS applications, cloud infrastructure, enterprise support",
      },
    ],
    businessChallenge: [
      "Following a leadership change, the client experienced significant disruption due to the departure of multiple key personnel who were critical to application management, cloud operations, and domain-specific expertise. The absence of documented processes and institutional knowledge created operational instability, delayed customer response times, and gaps in cloud governance. These challenges posed a direct threat to business continuity, customer trust, and the platform’s ability to scale efficiently.",
      "The new leadership required a single accountable partner who could rapidly stabilize operations, enforce governance, and ensure seamless service delivery while enabling future growth initiatives.",
    ],

    midImage: AgriMid,

    solutions:
      "BCPL assumed complete ownership of the client’s SaaS application ecosystem and cloud infrastructure, delivering 24x7 Managed Services with structured governance, clearly defined SLAs, and robust operational processes.",
    solutionsIntro: `BCPL assumed complete ownership of the client’s SaaS application ecosystem and cloud infrastructure, delivering 24x7 Managed Services with structured governance, clearly defined SLAs, and robust operational processes.`,

    solutionsSubheading: "Scope Included:",

    solutionPoints: [
      "Application operations, real-time monitoring, and incident management to ensure uninterrupted service delivery",
      "Cloud infrastructure management, performance optimization, security enforcement, and cost governance",
      "Production support including bug resolution, performance tuning, and proactive issue prevention",
      "Continuous enhancements, release management, and deployment oversight to accelerate feature delivery",
      "Customer support tailored to enterprise expectations, ensuring high customer satisfaction",
      "Deep agribusiness and supply chain domain support to bridge knowledge gaps and enable informed decision-making",
    ],

    roiIntroLine1: "Business Impact & Strategic Value",

    roiIntroLine2:
      "Key improvements were achieved across planning efficiency, operational accuracy, and regulatory compliance.",
    roiItems: [
      {
        icon: Achievement,
        percent: "99%",
        title: "Uptime Achievement",
        description:
          "Zero disruption during leadership transition Enterprise customer confidence and trust",
      },
      {
        icon: Operational,
        percent: "",
        title: "Operational Excellence",
        description:
          "Reduced incidents by 50% and improved Mean Time to Resolution (MTTR) by 60%, establishing stable and predictable operations",
      },
      {
        icon: Cost,
        percent: "35-40%",
        title: "Cloud Cost Savings",
        description:
          "Through governance & performance tuning  and resource rationalization",
      },
      {
        icon: Accelerated,
        percent: "30%",
        title: "Accelerated Delivery",
        description:
          "Faster enhancements & releases improved time-to-value for customers and supporting business growth",
      },

      /* items WITHOUT percent */
      {
        icon: Strategic,
        title: "Strategic Independence",
        description:
          "Eliminated dependency on key personnel, enabling client leadership to focus on innovation, strategy, and scaling the business",
      },
    ],

    takeawayText:
      "BCPL successfully transformed a high-risk leadership and operational transition into a stable, scalable, and efficient operating model, turning operational management into a strategic advantage. By combining proactive management, structured governance, and deep domain expertise, BCPL enabled the client not only to survive the transition but to thrive, achieving greater operational stability, predictable performance, and enhanced cost efficiency laying a strong foundation for sustainable growth and long-term success in the Agritech space.",

    cta: {
      title: "Unlock Growth with Bharat Clouds",
      description:
        "Discover how BCPL can help your organization achieve operational stability, optimize cloud and application performance, and turn critical transitions into opportunities for growth. Contact us today to explore tailored Managed Services solutions that align with your business objectives.",
      button: {
        text: "Talk To Us",
        link: "/lets-talk",
        variant: "primary",
      },
    },

    readingTitle:
      "Ensuring Stability in Agritech SaaS: Leadership Transition Without Disruption",

    // socialLinks: {
    //   linkedin: "https://linkedin.com/company/bharatcloud",
    //   twitter: "https://twitter.com/bharatcloud",
    //   facebook: "https://facebook.com/bharatcloud",
    //   share: "#share",
    // },

    recommendations: [
      {
        image: FleetTop,
        title: "Driving Revenue Through Intelligent Fleet Automation",
        link: "/case-studies/intelligent-fleet-automation-revenue-growth",
      },
      // {
      //   image:
      //     "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      //   title: "AI-Powered Supply Chain Optimization",
      //   link: "/case-study/supply-chain",
      // },
      // {
      //   image:
      //     "https://images.unsplash.com/photo-1531973576160-7125cd663d86?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      //   title: "Cloud Migration Success Story",
      //   link: "/case-study/cloud-migration",
      // },
    ],
  };

  return <CaseStudy {...mockProps} />;
}

export default CaseStudyTwo;
